import { render, staticRenderFns } from "./UIListItem.vue?vue&type=template&id=dd3116ba&scoped=true"
import script from "./UIListItem.vue?vue&type=script&lang=js"
export * from "./UIListItem.vue?vue&type=script&lang=js"
import style0 from "./UIListItem.vue?vue&type=style&index=0&id=dd3116ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3116ba",
  null
  
)

export default component.exports